import React from 'react';

interface IProps {
	menu: React.ReactElement;
	children?: React.ReactNode;
}

export const DropdownRender: React.FC<IProps> = ({ menu, children }) => (
	<>
		<div className="py-2 px-3.5 border-0 border-b border-solid border-grey-1400 flex flex-col gap-2.5">
			{children}
		</div>
		{menu}
	</>
);
